var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8414_17257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78571 2.29004C4.78571 1.8318 5.14742 1.47754 5.57143 1.47754H6.42857C6.85258 1.47754 7.21429 1.8318 7.21429 2.29004V11.915C7.21429 12.3733 6.85258 12.7275 6.42857 12.7275H5.57143C5.14742 12.7275 4.78571 12.3733 4.78571 11.915V2.29004ZM0.5 7.54004C0.5 7.0818 0.861704 6.72754 1.28571 6.72754H2.14286C2.56687 6.72754 2.92857 7.0818 2.92857 7.54004V11.915C2.92857 12.3733 2.56687 12.7275 2.14286 12.7275H1.28571C0.861704 12.7275 0.5 12.3733 0.5 11.915V7.54004ZM9.85714 3.22754H10.7143C11.1383 3.22754 11.5 3.5818 11.5 4.04004V11.915C11.5 12.3733 11.1383 12.7275 10.7143 12.7275H9.85714C9.43313 12.7275 9.07143 12.3733 9.07143 11.915V4.04004C9.07143 3.5818 9.43313 3.22754 9.85714 3.22754Z",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8414_17257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    fill: "currentColor",
    transform: "translate(0 0.102539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart_icon.3739131dcbc4095a57069e26488103de.svg";
export { ForwardRef as ReactComponent };